// Default maxWeight is 30
export const getMaxWeight = (maxWeight?: number) => (maxWeight ? maxWeight : 30);

// Hard coded as JPOS does not provide this property
export const getRepeatability = (UOMPrecision: number, weightUnit: string): number =>
  weightUnit === 'kg' && UOMPrecision === 3 ? 0.005 : 0.01;

// Get mininum weight from JPOS does not work now
export const getMinWeight = (
  UOMPrecision: number,
  weightUnit: string,
  minWeight?: number,
): number => {
  if (minWeight) {
    return minWeight;
  } else {
    const repeatability = getRepeatability(UOMPrecision, weightUnit);
    // const requiredAccuracy = 10%;
    // const minWeight = 2 * repeatability / requiredAccuracy;
    return 2 * repeatability * 10;
  }
};

export const getNofDivision = (
  UOMPrecision: number,
  weightUnit: string,
  maxWeight?: number,
): number => {
  //n = maxWeight / repeatability , use string operation to avoid division
  maxWeight = getMaxWeight(maxWeight);
  if (weightUnit === 'kg' && UOMPrecision === 3) {
    return maxWeight * 200;
  } else {
    return maxWeight * 100;
  }
};

export const getWeightUnitFromJPOSWeightUnit = (weightUnit: string): string => {
  switch (weightUnit) {
    case 'GRAM':
      return 'gm';
    case 'KILOGRAM':
      return 'kg';
    case 'OUNCE':
      return 'oz';
    case 'POUND':
      return 'lb';
    default:
      return 'lb';
  }
};
